import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { pcfRoutes } from '../pcf-routes';
import { useIngredientDetailContext } from './ingredient-detail-context';
import { useIngredientDetailTabs } from './tabs';

export default function IngredientDetailLayout() {
  const { item, status, referrer } = useIngredientDetailContext();
  const tabs = useIngredientDetailTabs();
  const navigate = useNavigate();

  const getReferrerLabel = (referrer: string) => {
    if (referrer.includes('collections')) {
      return 'Back to collection';
    }
    return 'Back to ingredients';
  };

  return (
    <Page
      name={item?.name}
      page="layout"
      status={status}
      title={`${item?.name} - Ingredient Detail`}
      flexFullHeight
    >
      <PageHeader
        name={item?.name}
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Products',
            url: generatePath(pcfRoutes.PRODUCTS),
          },
          {
            label: 'Ingredients',
            url: generatePath(pcfRoutes.PRODUCT_COMPONENTS_INGREDIENTS),
          },
          {
            label: item?.name || 'Item',
            url: generatePath(pcfRoutes.PRODUCT_COMPONENTS_INGREDIENTS_DETAIL, {
              ingredient_uuid: item?.uuid || '',
            }),
          },
        ]}
        toolbar={
          referrer ? (
            <Button
              variant="ghost"
              onClick={() => navigate(referrer)}
              icon={<Icons.chevronLeft className="size-4" />}
            >
              {getReferrerLabel(referrer)}
            </Button>
          ) : undefined
        }
      />
      <Outlet />
    </Page>
  );
}
